function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWa",
  x1: 15.072,
  x2: 24.111,
  y1: 13.624,
  y2: 24.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e3e3e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e2e2e2"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWa)",
  d: "M42.485,40H5.515C4.126,40,3,38.874,3,37.485V10.515C3,9.126,4.126,8,5.515,8h36.969 C43.874,8,45,9.126,45,10.515v26.969C45,38.874,43.874,40,42.485,40z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWb",
  x1: 26.453,
  x2: 36.17,
  y1: 25.441,
  y2: 37.643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f5f5f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#eee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eee"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWb)",
  d: "M42.485,40H8l37-29v26.485C45,38.874,43.874,40,42.485,40z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWc",
  x1: 3,
  x2: 45,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d74a39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c73d28"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWc)",
  d: "M5.515,8H8v32H5.515C4.126,40,3,38.874,3,37.485V10.515C3,9.126,4.126,8,5.515,8z M42.485,8 H40v32h2.485C43.874,40,45,38.874,45,37.485V10.515C45,9.126,43.874,8,42.485,8z"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWd",
  x1: 24,
  x2: 24,
  y1: 8,
  y2: 38.181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.03
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWd)",
  d: "M42.485,40H30.515L3,11.485v-0.969C3,9.126,4.126,8,5.515,8h36.969 C43.874,8,45,9.126,45,10.515v26.969C45,38.874,43.874,40,42.485,40z"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWe",
  x1: 3,
  x2: 45,
  y1: 17.73,
  y2: 17.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f5f5f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f5f5f5"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWe)",
  d: "M43.822,13.101L24,27.459L4.178,13.101C3.438,12.565,3,11.707,3,10.793v-0.278 C3,9.126,4.126,8,5.515,8h36.969C43.874,8,45,9.126,45,10.515v0.278C45,11.707,44.562,12.565,43.822,13.101z"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "6769YB8EDCGhMGPdL9zwWf",
  x1: 24,
  x2: 24,
  y1: 8.446,
  y2: 27.811,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e05141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#de4735"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#6769YB8EDCGhMGPdL9zwWf)",
  d: "M42.485,8h-0.3L24,21.172L5.815,8h-0.3C4.126,8,3,9.126,3,10.515v0.278 c0,0.914,0.438,1.772,1.178,2.308L24,27.459l19.822-14.358C44.562,12.565,45,11.707,45,10.793v-0.278C45,9.126,43.874,8,42.485,8z"
});

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.49c66076.svg";
export { ForwardRef as ReactComponent };